import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { OptionList_OptionListPage_Query } from "./query";

type Props = {
	hotelID: string;
};

export const useFetchOptionList = ({ hotelID }: Props) => {
	const { data } = useCustomSuspenseQuery(OptionList_OptionListPage_Query, {
		variables: {
			hotelID,
		},
		fetchPolicy: "network-only",
	});

	return {
		data,
	};
};
